import { createFileRoute, Link, notFound } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { formatPostDate, getPostBySlug } from '../../lib/blog';

export const Route = createFileRoute('/blog/$slug')({
  component: BlogPostPage,
  loader: ({ params }) => {
    const post = getPostBySlug(params.slug);
    if (!post) throw notFound();
    return { post };
  },
});

function BlogPostPage() {
  const { post } = Route.useLoaderData();
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="container-page max-w-3xl">
        <Link
          to="/blog"
          className="inline-flex items-center gap-1.5 text-sm text-ink-2 transition-colors hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to blog
        </Link>

        <h1 className="mt-8 text-4xl font-semibold tracking-tight text-ink md:text-5xl">
          {post.title}
        </h1>
        <p className="mt-4 text-sm text-ink-3">{formatPostDate(post.date)}</p>

        <article className="prose prose-neutral mt-10 max-w-none prose-a:text-primary hover:prose-a:text-primary-dark">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.body}</ReactMarkdown>
        </article>
      </div>
    </section>
  );
}
